// extracted by css-extract-rspack-plugin
export default {"diffHeaderWrapper":"Diff-module__diffHeaderWrapper__VTI5w"};